export const getHardwareConcurrency = t => {
  try {
    return navigator.hardwareConcurrency || t("global.notSupported");
  } catch {
    return t("global.notSupported");
  }
};
